/* Autana · página de producto: variantes sincronizadas entre tarjetas, barra fija y ventana de oferta.
   Sin JS todo sigue comprando 1 unidad: la compra nunca depende de este archivo. */
/* Imágenes diferidas (data-au-src): se cargan al acercarse a la pantalla, para que las fotos de abajo
   no le quiten ancho de banda a la foto principal. Respaldo: 3,5 s después del load (en el hero). */
(function(){
  var imgs=[].slice.call(document.querySelectorAll('[data-au-src]'));
  if(!imgs.length) return;
  var cargar=function(i){ if(!i.dataset.auSrc) return; i.srcset=i.dataset.auSrcset; i.src=i.dataset.auSrc; i.removeAttribute('data-au-src'); };
  if(!('IntersectionObserver' in window)){ imgs.forEach(cargar); return; }
  var io=new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ cargar(e.target); io.unobserve(e.target); } }); },{rootMargin:'700px 0px'});
  imgs.forEach(function(i){ io.observe(i); });
})();

(function(){
  var forms=[].slice.call(document.querySelectorAll('[data-au-buy]'));
  if(!forms.length) return;
  var precio=function(c){ return (Math.round(c)/100).toFixed(2).replace(/\.00$/,'')+'$'; };

  /* 1 · Variantes: elegir en una tarjeta cambia todas (hero, oferta y barra fija compran lo mismo) */
  var actual=null;
  function aplicar(r){
    actual={id:+r.value,p:+r.dataset.cents,t:r.parentNode.textContent.trim()};
    forms.forEach(function(f){
      var q=f.querySelector('[data-au-qty]'); if(q) q.name='updates['+r.value+']';
      var o=f.querySelector('.au-var input[type=radio][value="'+r.value+'"]'); if(o) o.checked=true;
      var a=f.querySelector('[data-au-antes]'); if(a&&r.dataset.antes) a.textContent=r.dataset.antes;
      var ab=f.querySelector('[data-au-ahorra-btn]');
      if(ab){ if(r.dataset.antesCents){ ab.hidden=false; ab.textContent='Ahorras '+precio(+r.dataset.antesCents-(+r.dataset.cents)); } else { ab.hidden=true; } }
      var ev=f.querySelector('[data-au-envio]'); if(ev) ev.classList.toggle('is-ok', +r.dataset.cents>=5500);
      var bs=f.querySelector('[data-au-bs]'); if(bs) bs.textContent=Math.round(+r.dataset.cents*+bs.dataset.tasa/100).toLocaleString('es-VE')+' Bs';
    });
    document.querySelectorAll('[data-au-price],[data-au-pill]').forEach(function(e){ e.textContent=r.dataset.price; });
  }
  forms.forEach(function(f){
    f.querySelectorAll('.au-var input[type=radio]').forEach(function(r){ r.addEventListener('change',function(){ aplicar(r); }); });
  });
  var r0=forms[0].querySelector('.au-var input[type=radio]:checked');
  if(r0) aplicar(r0);
  else { var q0=forms[0].querySelector('[data-au-qty]'), pr=forms[0].querySelector('[data-au-price]');
    /* Con cuotas (Cashea) no hay [data-au-price]: el precio sale de data-au-cashea (centavos). */
    var pc=forms[0].querySelector('[data-au-cashea]');
    actual={id:+q0.name.replace(/\D/g,''),p:pr?Math.round(parseFloat(pr.textContent)*100):(pc?+pc.getAttribute('data-au-cashea'):0),t:''}; }

  /* 1b · Diseño: elegir en una tarjeta lo marca en todas (atributo del pedido) */
  document.addEventListener('change',function(e){
    var r=e.target; if(!r.matches||!r.matches('[data-au-dis] input[type=radio]')) return;
    document.querySelectorAll('[data-au-dis] input[type=radio]').forEach(function(o){ if(o.value===r.value) o.checked=true; });
    document.querySelectorAll('[data-au-dis-n]').forEach(function(n){ n.textContent=r.value; });
  });

  /* 2 · Barra fija: visible desde el primer pantallazo y siempre que no haya otro botón de compra a la vista
     (MIDA 22/10/2026: en celular la foto llenaba la pantalla y el botón quedaba a 1,5 pantallas).
     La burbuja de WhatsApp sube sobre la barra y se esconde cuando hay un botón a la vista (lo tapaba). */
  var s=document.querySelector('[data-au-sticky]'), hero=document.getElementById('au-f-hero'), of=document.getElementById('au-f-oferta');
  if(s&&hero){
    var pend=false, raiz=document.documentElement;
    var fuera=function(el){ var r=el.getBoundingClientRect(); return r.top>window.innerHeight||r.bottom<0; };
    var mirar=function(){ pend=false;
      var on=fuera(hero)&&(!of||fuera(of));
      raiz.classList.toggle('au-st-on',on); raiz.classList.toggle('au-cta-vis',!on); raiz.style.setProperty('--au-st-h',s.offsetHeight+'px');
      s.classList.toggle('is-on',on); s.setAttribute('aria-hidden',on?'false':'true');
      var bt=s.querySelector('button'); if(bt) bt.tabIndex=on?0:-1;
    };
    window.addEventListener('scroll',function(){ if(!pend){ pend=true; requestAnimationFrame(mirar); } },{passive:true});
    mirar();
  }

  /* 3 · "Elige cómo lo llevas": cualquier botón de compra la abre una vez; el kit elegido fija las cantidades */
  var up=document.querySelector('[data-au-up]');
  if(!up) return;
  var dv=document.querySelector('[data-au-up-vars]');
  var all=dv?JSON.parse(dv.textContent):[];
  var pct2=+up.dataset.pct2||0;
  var visto=false, fActual=null, extra=null, html=document.documentElement;
  function elegir(){
    if(!all.length) return null;
    var idx=+up.dataset.idx||0, mismo=up.dataset.mismo==='1';
    var v=all[idx]&&all[idx].ok?all[idx]:null;
    if(mismo&&(!v||v.id===actual.id)) v=all.filter(function(x){ return x.ok&&x.id!==actual.id; })[0]||null;
    return v;
  }
  var kits={};
  function pintar(){
    var sel=up.querySelector('input[name=au-pk]:checked'); if(!sel) return;
    var k=kits[sel.value]; up.querySelector('[data-au-up-total]').textContent=precio(k.p);
    up.querySelector('[data-au-up-cta]').textContent=(sel.value==='solo'||sel.dataset.first==='1')?'Continuar':'Llevar el kit';
    up.querySelectorAll('.au-pk').forEach(function(l){ l.classList.toggle('is-on',l.contains(sel)); });
    var ah=up.querySelector('[data-au-up-ahorra]');
    if(ah){ if(k.a&&k.a>k.p){ ah.hidden=false; ah.textContent='Ahorras '+precio(k.a-k.p); } else { ah.hidden=true; } }
  }
  var modoVar=up.dataset.modo==='variantes';
  function abrir(f){
    fActual=f;
    if(modoVar){
      up.querySelectorAll('input[name=au-pk]').forEach(function(i){ kits[i.value]={p:+i.dataset.p,a:+i.dataset.antes||0,q:[[+i.value,1]]}; });
      if(!up.querySelector('input[name=au-pk]:checked')) up.querySelector('input[name=au-pk]').checked=true;
      pintar(); up.hidden=false; html.classList.add('au-up-on');
      requestAnimationFrame(function(){ up.classList.add('is-on'); });
      up.querySelector('[data-au-up-si]').focus({preventScroll:true});
      return true;
    }
    extra=elegir();
    var nm=(actual.t&&actual.t.toLowerCase()!=='default title')?actual.t:'1 unidad';
    kits.solo={p:actual.p,q:[[actual.id,1]]};
    var ds=up.querySelector('[data-k-desc-solo]'); if(ds) ds.textContent=nm;
    up.querySelector('[data-k-p-solo]').textContent=precio(actual.p);
    var lc=up.querySelector('input[value=cruce]');
    if(lc){
      if(extra){ kits.cruce={p:actual.p+extra.p,q:[[actual.id,1],[extra.id,1]]}; up.querySelector('[data-k-p-cruce]').innerHTML=precio(actual.p+extra.p)+'<small>+'+precio(extra.p)+'</small>'; lc.closest('.au-pk').hidden=false; }
      else { lc.closest('.au-pk').hidden=true; if(lc.checked) up.querySelector('input[value=solo]').checked=true; }
    }
    var ld=up.querySelector('input[value=dos]');
    if(ld){ var p2=Math.round(actual.p*2*(1-pct2/100)); kits.dos={p:p2,a:actual.p*2,q:[[actual.id,2]]};
      up.querySelector('[data-k-p-dos]').innerHTML=precio(p2)+(pct2?'<small>Ahorras '+precio(actual.p*2-p2)+'</small>':''); }
    if(!up.querySelector('input[name=au-pk]:checked')) up.querySelector('input[name=au-pk]').checked=true;
    pintar();
    up.hidden=false; html.classList.add('au-up-on');
    requestAnimationFrame(function(){ up.classList.add('is-on'); });
    up.querySelector('[data-au-up-si]').focus({preventScroll:true});
    return true;
  }
  function cerrar(){ up.classList.remove('is-on'); html.classList.remove('au-up-on'); setTimeout(function(){ up.hidden=true; },250); }
  up.addEventListener('change',function(e){ if(e.target.name==='au-pk') pintar(); });
  forms.forEach(function(f){
    f.addEventListener('submit',function(e){
      if(visto) return;
      visto=true;
      if(abrir(f)) e.preventDefault();
    });
  });
  up.querySelectorAll('[data-au-up-x]').forEach(function(b){ b.addEventListener('click',cerrar); });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&!up.hidden) cerrar(); });
  function misVariantes(){
    if(modoVar) return all.map(function(x){ return x.id; });
    var ids=[].slice.call(document.querySelectorAll('.au-var input[type=radio]')).map(function(r){ return +r.value; });
    return ids.length?ids:[actual.id];
  }
  up.querySelector('[data-au-up-si]').addEventListener('click',function(){
    var sel=up.querySelector('input[name=au-pk]:checked'), k=kits[sel?sel.value:'solo'];
    fActual.querySelectorAll('[data-au-extra]').forEach(function(x){ x.remove(); });
    var q=fActual.querySelector('[data-au-qty]');
    var nuevos={}; k.q.forEach(function(it){ nuevos[it[0]]=true; });
    /* Si antes se envió otra variante/kit de este producto y quedó en el carrito, ponerla en 0
       para que no se sumen dos kits del mismo producto al cambiar de elección. */
    try{
      var clave='au_last_'+misVariantes().slice().sort(function(a,b){return a-b;}).join('_');
      var prev=JSON.parse(localStorage.getItem(clave)||'[]');
      prev.forEach(function(id){
        if(!nuevos[id]){ var z=document.createElement('input'); z.type='hidden'; z.name='updates['+id+']'; z.value=0; z.setAttribute('data-au-extra',''); fActual.appendChild(z); }
      });
      localStorage.setItem(clave, JSON.stringify(Object.keys(nuevos).map(Number)));
    }catch(e){}
    k.q.forEach(function(it,i){
      if(i===0){ q.name='updates['+it[0]+']'; q.value=it[1]; return; }
      var n=document.createElement('input'); n.type='hidden'; n.name='updates['+it[0]+']'; n.value=it[1]; n.setAttribute('data-au-extra',''); fActual.appendChild(n);
    });
    if(window.auEnviar) window.auEnviar(fActual); else fActual.submit();
  });

  /* 4 · Movimiento: lo que entra en pantalla aparece con un leve ascenso (no toca el primer pantallazo) */
  if('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches){
    var sel='.au-sec .au-eyebrow,.au-sec .au-h2,.au-sec .au-lista li,.au-sec .au-paso,.au-sec .au-tabla__r,.au-sec .au-faq details,.au-claim h2,.au-claim p,.au-mid h2,.au-mid__btn,.au-split__img,.au-sirve__i,.au-calc__box,.au-garantia';
    var els=[].slice.call(document.querySelectorAll(sel)).filter(function(e){ return !e.closest('.au-pdp')&&!e.classList.contains('au-rv'); });
    els.forEach(function(e){ e.classList.add('au-a'); var sib=[].indexOf.call(e.parentNode.children,e); e.style.transitionDelay=Math.min(sib,6)*70+'ms'; });
    var io2=new IntersectionObserver(function(es){ es.forEach(function(x){ if(x.isIntersecting){ x.target.classList.add('is-in'); io2.unobserve(x.target); } }); },{rootMargin:'0px 0px -6% 0px'});
    els.forEach(function(e){ io2.observe(e); });
    html.classList.add('au-motion');
  }
})();

/* 5 · Compra con evento "agregar al carrito" para Meta (29/10/2026). El formulario fija cantidades con /cart/update, que
   Shopify no cuenta como "agregar al carrito", y el embudo de Meta quedaba en 0. Ahora: pone en 0 las líneas de este
   producto, las agrega con /cart/add.js (Shopify emite product_added_to_cart → AddToCart en el píxel) y va al checkout.
   Sigue siendo idempotente: dos toques dejan la misma cantidad. Si algo falla, se envía el formulario como antes. */
(function(){
  function post(url,body){ return fetch(url,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)}).then(function(r){ if(!r.ok) throw new Error(r.status); return r.json(); }); }
  window.auEnviar=function(f){
    if(f.dataset.auEnviando) return; f.dataset.auEnviando='1';
    var ups={}, items=[], attrs={};
    f.querySelectorAll('input[name^="updates["]').forEach(function(i){ var id=+i.name.slice(8,-1), q=+i.value||0; ups[id]=0; if(q>0) items.push({id:id,quantity:q}); });
    f.querySelectorAll('[name^="attributes["]').forEach(function(i){ if((i.type!=='radio'&&i.type!=='checkbox')||i.checked) attrs[i.name.slice(11,-1)]=i.value; });
    if(!items.length){ f.submit(); return; }
    var body={updates:ups}; if(Object.keys(attrs).length) body.attributes=attrs;
    post('/cart/update.js',body)
      .then(function(){ return post('/cart/add.js',{items:items}); })
      .then(function(){ return window.auAntesDeCheckout ? window.auAntesDeCheckout() : null; })
      .then(function(){ window.location.href='/checkout'; })
      .catch(function(){ delete f.dataset.auEnviando; f.submit(); });
  };
  window.addEventListener('pageshow',function(){ document.querySelectorAll('form[data-au-buy]').forEach(function(f){ delete f.dataset.auEnviando; }); });
  document.addEventListener('submit',function(e){
    var f=e.target; if(!f.matches||!f.matches('form[data-au-buy]')||e.defaultPrevented) return;
    e.preventDefault(); window.auEnviar(f);
  });
})();

